<template lang="pug">
  div.app.flex-row.align-items-center(style='background: white;')
    div.container
      div.row.justify-content-center
        div.col-md-4.col-sm-12
          b-form
            div.mb-4.text-center
              img(src='static/img/logo.png', alt='')
            b-input-group.mb-3(left='<i class="icon-user"></i>')
              b-form-input(type='email', autocomplete='username', placeholder='Email', v-model='login.email')
            b-input-group.mb-3(left='<i class="icon-lock"></i>' v-if='!fp')
              b-form-input(type='password', autocomplete='current-password', placeholder='Password', v-model='login.password')
            div.row
              b-button.px-4.mx-auto(variant='primary', type='submit', @click.prevent='logIn' v-if='!fp') Login
              b-button.px-4.mx-auto(variant='primary', type='submit', @click.prevent='forgetPassword' v-else) Forgot password
            div.row
              a.mx-auto.text-muted.mt-1(href='#' @click='fp=!fp')
                span(v-if='!fp') Forgot password?
                span(v-else) Login
              //- div.col-6.text-right
                button.btn.btn-link.px-0(type='button') Forget password? //
</template>

<script>
import { auth } from '@/firebase'

export default {
  name: 'Login',
  data() {
    return {
      login: {
        email: '',
        password: '',
      },
      fp: false,
    }
  },
  methods: {
    logIn: function() {
      auth.signInWithEmailAndPassword(this.login.email, this.login.password).then(
        (user) => {
          this.$router.replace('/')
          this.$snotify.success('You have successfully logged in')
        },
        (err) => {
          this.$snotify.error('Oops. ' + err.message)
        }
      )
    },
    forgetPassword: function() {
      auth.sendPasswordResetEmail(this.login.email).then(
        (user) => {
          this.$snotify.success('Reset email has been sent!')
        },
        () => {
          this.$snotify.success('Reset email has been sent!')
        }
      )
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Login.vue?6250e4f8